import React from 'react';
import { Link } from 'react-router-dom'; // Import Link

const SidebarNav = ({ menuItems, activeItemText }) => {
    return (
        <ul className="nav nav-pills flex-column mb-auto">
            {menuItems.map((item) => {
                const IconComponent = item.icon;
                const isActive = item.text === activeItemText;
                return (
                    <li className="nav-item" key={item.text}> {/* Use Link for internal navigation */}
                        <Link to={item.href} className={`nav-link d-flex align-items-center ${isActive ? 'active' : ''} ${isActive ? '' : 'text-dark'}`} aria-current={isActive ? 'page' : undefined}>
                            <IconComponent className="me-2" fill={isActive ? "#01844B" : "#5E5E5E"} />
                            {item.text}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default SidebarNav;